import {
  StaticMessage,
  User,
  UserAddress,
  UserAddressPayload,
  UserTimeZone,
  user,
} from '@toggle/toggle';

import { apiFetch } from '~/utils/api-fetch/apiFetch';

// export const getUserData = () => {
//   return apiFetch<User>(user.user.path, {
//     schema: user.user.schema,
//   });
// };

export const putUserData = (body: User) => {
  return apiFetch<User>(user.updateUser.path(body.id), {
    schema: user.updateUser.schema,
    method: 'put',
    body,
  });
};

export const putUserTimezone = (body: UserTimeZone) => {
  return apiFetch<StaticMessage>(user.userTimezone.path, {
    schema: user.userTimezone.schema,
    method: 'put',
    body,
  });
};

export const putUserAddress = (body: UserAddressPayload) => {
  return apiFetch<UserAddress>(user.address.path, {
    schema: user.address.schema,
    method: 'put',
    body,
  });
};

export const getUserAddress = async () => {
  return apiFetch<UserAddress>(user.address.path, {
    schema: user.address.schema,
  });
};
